import React from 'react'
import '../../assets/styles/css/prescription.css'
import { Card, Page } from '../../components'
import { brDate } from '../../utils/date'

export default function PrescriptionView({
    prescriptions,
    loading,
    showBreadcrumbs = false,
}) {
    const noResults = prescriptions.length === 0 && !loading

    return (
        <Page
            title="Prescrições"
            hideBreadcrumb={!showBreadcrumbs}
            loading={loading}
        >
            {noResults && (
                <div className="no-prescriptions">
                    Nenhuma prescrição encontrada no posto selecionado.
                </div>
            )}
            {prescriptions.map(prescription => {
                const prescriptionText = (prescription.title || '').replace(
                    /&nbsp;/g,
                    ' '
                )
                return (
                    <div
                        style={{
                            marginBottom: 20,
                        }}
                        key={prescription.id}
                    >
                        <Card>
                            <div className="container_prescription">
                                <div>Data: {brDate(prescription.date)}</div>
                                <div style={{ fontWeight: 'bold' }}>
                                    {prescription.specialty}
                                </div>
                                <div>Profissional: {prescription.doctor}</div>
                                <div>
                                    <div style={{ fontWeight: 'bold' }}>
                                        Prescrição:
                                    </div>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: prescriptionText,
                                        }}
                                    />
                                </div>
                                <div className="conatiner_buttons">
                                    <a
                                        href={prescription.pdfUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="button_download"
                                    >
                                        Baixar Prescrição
                                    </a>
                                </div>
                            </div>
                        </Card>
                    </div>
                )
            })}
        </Page>
    )
}
